import { MouseEvent } from "react";

export const blockEvent = (e: MouseEvent<any> | MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
};
